import { profileConstants } from 'srcReact/MyProfile/constant'
import { lightProfileConstants as lpc } from './constants'

const initialState = {
  user: {},
  loading: false,
  error: null,
  interests: [],
  isModalOpen: false,
  userInput: null,
  interestGroups: {
    list: [],
    stats: {},
    loading: false,
    error: null
  },
  mixrs: {
    list: [],
    stats: {},
    loading: false,
    error: null
  },
  expertiseGroups: {
    list: [],
    stats: {},
    loading: false,
    error: null
  },
  promptActions: {
    loading: false,
    id: 0,
    error: '',
    success: false
  }
}

export function lightProfile(state = initialState, action) {
  switch (action.type) {
    case lpc.GET_LIGHT_PROFILE_REQUEST: {
      return {
        ...state,
        loading: true
      }
    }
    case lpc.GET_LIGHT_PROFILE_SUCCESS: {
      const {
        user,
        interests,
        interest_groups_for_light,
        interest_mixrs_for_light,
        status,
        expertise_groups_for_light
      } = action.response
      return {
        ...state,
        loading: false,
        user: user,
        interests: interests,
        error: '',
        userStatus: status,
        interestGroups: {
          ...state.groups,
          list: interest_groups_for_light?.list,
          stats: interest_groups_for_light?.stat
        },
        expertiseGroups: {
          ...state.expertiseGroups,
          list: expertise_groups_for_light?.list,
          stats: expertise_groups_for_light?.stat
        },
        mixrs: {
          list: interest_mixrs_for_light?.list,
          stats: interest_mixrs_for_light?.stat
        }
      }
    }
    case lpc.GET_LIGHT_PROFILE_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }

    case lpc.CLEAR_DATA: {
      return { ...initialState }
    }
    case lpc.LOAD_MORE_GROUPS_REQUEST: {
      const { isPagination, groupType } = action
      return {
        ...state,
        interestGroups:
          groupType === 'interest'
            ? {
                ...state.interestGroups,
                loading: true,
                list: isPagination ? [...state.interestGroups.list] : [],
                stats: isPagination ? { ...state.interestGroups.stats } : {}
              }
            : state.interestGroups,
        expertiseGroups:
          groupType === 'expertise'
            ? {
                ...state.expertiseGroups,
                loading: true,
                list: isPagination ? [...state.expertiseGroups.list] : [],
                stats: isPagination ? { ...state.expertiseGroups.stats } : {}
              }
            : state.expertiseGroups
      }
    }
    case lpc.LOAD_MORE_GROUPS_SUCCESS: {
      const {
        interest_groups_for_light: { list: interestList, stat: interestStat },
        expertise_groups_for_light: { list: expertiseList, stat: expertiseStat },
        isPagination,
        groupType
      } = action.updatedResponse
      let updatedList = []
      let newList = []
      let newStat = {}
      if (groupType === 'interest') {
        updatedList = [...state.interestGroups.list]
        newList = interestList
        newStat = interestStat
      } else {
        updatedList = [...state.expertiseGroups.list]
        newList = expertiseList
        newStat = expertiseStat
      }

      if (isPagination && newList) {
        updatedList = [...updatedList, ...newList]
      } else if (updatedList.length === 0) {
        updatedList = newList ? [...newList] : []
      }

      return {
        ...state,
        interestGroups:
          groupType === 'interest'
            ? {
                ...state.interestGroups,
                loading: false,
                list: updatedList,
                stats: newStat && { ...newStat }
              }
            : state.interestGroups,
        expertiseGroups:
          groupType === 'expertise'
            ? {
                ...state.expertiseGroups,
                loading: false,
                list: updatedList,
                stats: newStat && { ...newStat }
              }
            : state.expertiseGroups
      }
    }

    case lpc.LOAD_MORE_GROUPS_FAILURE: {
      return {
        ...state,
        interestGroups: {
          ...state.interestGroups,
          loading: false,
          error: action.error
        },
        expertiseGroups: {
          ...state.expertiseGroups,
          loading: false,
          error: action.error
        }
      }
    }

    case lpc.LOAD_MORE_MIXRS_REQUEST: {
      const isPagination = action.response
      return {
        ...state,
        mixrs: {
          ...state.mixrs,
          loading: true,
          list: isPagination ? [...state.mixrs.list] : [],
          stats: isPagination ? { ...state.mixrs.stats } : {}
        }
      }
    }
    case lpc.LOAD_MORE_MIXRS_SUCCESS: {
      const {
        interest_mixrs_for_light: { list, stat },
        isPagination
      } = action.updatedResponse
      let updatedList = [...state.mixrs.list]
      if (isPagination && list) {
        updatedList = [...state.mixrs.list, ...list]
      } else if (state.mixrs.list.length === 0) {
        updatedList = list ? [...list] : []
      }

      return {
        ...state,
        mixrs: {
          ...state.mixrs,
          loading: false,
          list: updatedList,
          stats: stat && { ...stat }
        }
      }
    }

    case lpc.LOAD_MORE_MIXRS_FAILURE: {
      return {
        ...state,
        mixrs: {
          ...state.mixrs,
          loading: false,
          error: action.error
        }
      }
    }

    case lpc.OPEN_MODAL: {
      return {
        ...state,
        isModalOpen: true,
        userInput: action.user
      }
    }

    case lpc.CLOSE_MODAL: {
      return {
        ...state,
        isModalOpen: false
      }
    }

    case profileConstants.ADD_INTEREST_SUCCESS: {
      const updatedInterest = state.interests?.map((interest) => {
        const found = action.response.find((i) => i.id === interest.id)
        if (found) {
          interest.is_common_with_logged_user = 1
        }
        return interest
      })
      return { ...state, interests: updatedInterest }
    }

    case profileConstants.LIKE_OR_DISLIKE_PROMPT_REQUEST:
    case profileConstants.DELETE_PROMPT_REQUEST: {
      return {
        ...state,
        promptActions: { ...state.promptActions, loading: true, id: action.data.prompt_id, success: false }
      }
    }
    case profileConstants.LIKE_OR_DISLIKE_PROMPT_SUCCESS:
    case profileConstants.DELETE_PROMPT_SUCCESS: {
      return {
        ...state,
        user: {
          ...state.user,
          prompts: {
            ...state.user.prompts,
            ...action.data.user_prompts
          }
        },
        promptActions: { ...state.promptActions, loading: false, id: action.prompt_id, success: true }
      }
    }
    case profileConstants.LIKE_OR_DISLIKE_PROMPT_FAILURE:
    case profileConstants.DELETE_PROMPT_FAILURE: {
      return {
        ...state,
        promptActions: { ...state.promptActions, loading: false, success: false }
      }
    }
    case profileConstants.UPDATE_PROMPT_SUCCESS: {
      return {
        ...state,
        user: {
          ...state.user,
          prompts: {
            ...state.user.prompts,
            ...action.data.user_prompts
          }
        }
      }
    }

    default:
      return state
  }
}
